import React from "react";
import TLabel from "../../../Library/Labels/TLabel";
import * as SCConst from "../NonComponents/SCConst";
import { SC_CreateCheckboxes } from "../NonComponents/SCUtil";
import SCDrawer from "./SCDrawer";
import TCheckBoxLabel from "../../../Library/Labels/TCheckBoxLabel";

class SCCharacteristicsDrawer extends SCDrawer {
    //==================================================================================================================
    //
    //                                                 Events
    //
    //==================================================================================================================

    onAllCharCheckBoxClick = (checked, event, name, caption, info) => {
        try {
            let configDrawer = this.state.configDrawer;
            let geoTypesIncluded = configDrawer[SCConst.geoTypesIncluded];
            let PEPFAR_CatsIncluded = configDrawer[SCConst.PEPFAR_CatsIncluded];
            let VMMC_CatsIncluded = configDrawer[SCConst.VMMC_CatsIncluded];
            let DREAMS_CatsIncluded = configDrawer[SCConst.DREAMS_CatsIncluded];
            let USG_AgenciesIncluded = configDrawer[SCConst.USG_AgenciesIncluded];
            let impPartnersIncluded = configDrawer[SCConst.impPartnersIncluded];
            let servDelivModesIncluded = configDrawer[SCConst.servDelivModesIncluded];
            let ownershipTypesIncluded = configDrawer[SCConst.ownershipTypesIncluded];

            /* (Un)check all characteristics checkboxes if the user clicks the 'All' checkbox, being
               sure to include element 0 (which is 'All' on the server). */
            for (let i = 0; i < geoTypesIncluded.length; i++) {
                geoTypesIncluded[i] = checked;
            }
            for (let i = 0; i < PEPFAR_CatsIncluded.length; i++) {
                PEPFAR_CatsIncluded[i] = checked;
            }
            for (let i = 0; i < VMMC_CatsIncluded.length; i++) {
                VMMC_CatsIncluded[i] = checked;
            }
            for (let i = 0; i < DREAMS_CatsIncluded.length; i++) {
                DREAMS_CatsIncluded[i] = checked;
            }
            for (let i = 0; i < USG_AgenciesIncluded.length; i++) {
                USG_AgenciesIncluded[i] = checked;
            }
            for (let i = 0; i < impPartnersIncluded.length; i++) {
                impPartnersIncluded[i] = checked;
            }
            for (let i = 0; i < servDelivModesIncluded.length; i++) {
                servDelivModesIncluded[i] = checked;
            }
            for (let i = 0; i < ownershipTypesIncluded.length; i++) {
                ownershipTypesIncluded[i] = checked;
            }

            this.setState({
                configDrawer: configDrawer,
            });
        } catch (exception) {
            alert(exception.name + ": " + exception.message);
        }
    };

    //==================================================================================================================
    //
    //                                                 Render
    //
    //==================================================================================================================

    renderCharacteristics = () => {
        try {
            const sectorID = 0;
            const styles = SCConst.styles;
            const configDrawer = this.state.configDrawer;
            const geoTypesIncluded = configDrawer[SCConst.geoTypesIncluded];
            const PEPFAR_CatsIncluded = configDrawer[SCConst.PEPFAR_CatsIncluded];
            const VMMC_CatsIncluded = configDrawer[SCConst.VMMC_CatsIncluded];
            const DREAMS_CatsIncluded = configDrawer[SCConst.DREAMS_CatsIncluded];
            const USG_AgenciesIncluded = configDrawer[SCConst.USG_AgenciesIncluded];
            const impPartnersIncluded = configDrawer[SCConst.impPartnersIncluded];
            const servDelivModesIncluded = configDrawer[SCConst.servDelivModesIncluded];
            const ownershipTypesIncluded = configDrawer[SCConst.ownershipTypesIncluded];

            /* If all characteristics are included, then allCharCheckBox will be true.
               Otherwise, it will be false. We could have alternatively checked element 0 of
               each array, since 0 is All. */
            let allCharacteristicsChecked = true;

            let i = 1;
            while (i < geoTypesIncluded.length && allCharacteristicsChecked) {
                allCharacteristicsChecked = geoTypesIncluded[i];
                i++;
            }

            i = 1;
            while (i < PEPFAR_CatsIncluded.length && allCharacteristicsChecked) {
                allCharacteristicsChecked = PEPFAR_CatsIncluded[i];
                i++;
            }

            i = 1;
            while (i < VMMC_CatsIncluded.length && allCharacteristicsChecked) {
                allCharacteristicsChecked = VMMC_CatsIncluded[i];
                i++;
            }

            i = 1;
            while (i < DREAMS_CatsIncluded.length && allCharacteristicsChecked) {
                allCharacteristicsChecked = DREAMS_CatsIncluded[i];
                i++;
            }

            i = 1;
            while (i < USG_AgenciesIncluded.length && allCharacteristicsChecked) {
                allCharacteristicsChecked = USG_AgenciesIncluded[i];
                i++;
            }

            i = 1;
            while (i < impPartnersIncluded.length && allCharacteristicsChecked) {
                allCharacteristicsChecked = impPartnersIncluded[i];
                i++;
            }

            i = 1;
            while (i < servDelivModesIncluded.length && allCharacteristicsChecked) {
                allCharacteristicsChecked = servDelivModesIncluded[i];
                i++;
            }

            i = 1;
            while (i < ownershipTypesIncluded.length && allCharacteristicsChecked) {
                allCharacteristicsChecked = ownershipTypesIncluded[i];
                i++;
            }

            const allCharCheckBox = (
                <TCheckBoxLabel
                    caption={"All"}
                    enabled={true}
                    value={allCharacteristicsChecked}
                    info={null}
                    onClick={this.onAllCharCheckBoxClick}
                    key={"AllChar"}
                    style={{ height: "auto", margin: "margin: 0px 0px 0px 0px" }}
                    labelStyle={{ fontSize: 13 }}
                />
            );

            const urbanRuralDiv = (
                <div style={styles.category}>
                    <TLabel
                        caption={"Rural vs Urban"}
                        style={styles.label}
                    />
                    <div style={styles.checkboxes}>
                        {SC_CreateCheckboxes(
                            SCConst.geoTypesIncluded,
                            "geoTypesStr",
                            true,
                            sectorID,
                            configDrawer,
                            this.props.displayOL,
                            this.onCheckboxChange
                        )}
                    </div>
                </div>
            );

            const PEPFAR_CatDiv = (
                <div style={styles.category}>
                    <TLabel
                        caption={"PEPFAR categories"}
                        style={styles.label}
                    />
                    <div style={styles.checkboxes}>
                        {SC_CreateCheckboxes(
                            SCConst.PEPFAR_CatsIncluded,
                            "PEPFAR_CatsStr",
                            true,
                            sectorID,
                            configDrawer,
                            this.props.displayOL,
                            this.onCheckboxChange
                        )}
                    </div>
                </div>
            );

            const VMMC_CatDiv = (
                <div style={styles.category}>
                    <TLabel
                        caption={"VMMC categories"}
                        style={styles.label}
                    />
                    <div style={styles.checkboxes}>
                        {SC_CreateCheckboxes(
                            SCConst.VMMC_CatsIncluded,
                            "VMMC_CatsStr",
                            true,
                            sectorID,
                            configDrawer,
                            this.props.displayOL,
                            this.onCheckboxChange
                        )}
                    </div>
                </div>
            );

            const DREAMS_Div = (
                <div style={styles.category}>
                    <TLabel
                        caption={"DREAMS"}
                        style={styles.label}
                    />
                    <div style={styles.checkboxes}>
                        {SC_CreateCheckboxes(
                            SCConst.DREAMS_CatsIncluded,
                            "DREAMS_CatsStr",
                            true,
                            sectorID,
                            configDrawer,
                            this.props.displayOL,
                            this.onCheckboxChange
                        )}
                    </div>
                </div>
            );

            const USG_AgenciesDiv = (
                <div style={styles.category}>
                    <TLabel
                        caption={"USG agencies"}
                        style={styles.label}
                    />
                    <div style={styles.checkboxes}>
                        {SC_CreateCheckboxes(
                            SCConst.USG_AgenciesIncluded,
                            "USG_AgenciesStr",
                            true,
                            sectorID,
                            configDrawer,
                            this.props.displayOL,
                            this.onCheckboxChange
                        )}
                    </div>
                </div>
            );

            const implPartnersDiv = (
                <div style={styles.category}>
                    <TLabel
                        caption={"Implementing partners"}
                        style={styles.label}
                    />
                    <div style={styles.checkboxes}>
                        {SC_CreateCheckboxes(
                            SCConst.impPartnersIncluded,
                            "impPartnersStr",
                            true,
                            sectorID,
                            configDrawer,
                            this.props.displayOL,
                            this.onCheckboxChange
                        )}
                    </div>
                </div>
            );

            const servDelivModesDiv = (
                <div style={styles.category}>
                    <TLabel
                        caption={"Service delivery modes"}
                        style={styles.label}
                    />
                    <div style={styles.checkboxes}>
                        {SC_CreateCheckboxes(
                            SCConst.servDelivModesIncluded,
                            "servDelivModesStr",
                            true,
                            sectorID,
                            configDrawer,
                            this.props.displayOL,
                            this.onCheckboxChange
                        )}
                    </div>
                </div>
            );

            const ownershipDiv = (
                <div style={styles.category}>
                    <TLabel
                        caption={"Ownership"}
                        style={styles.label}
                    />
                    <div style={styles.checkboxes}>
                        {SC_CreateCheckboxes(
                            SCConst.ownershipTypesIncluded,
                            "ownershipTypesStr",
                            true,
                            sectorID,
                            configDrawer,
                            this.props.displayOL,
                            this.onCheckboxChange
                        )}
                    </div>
                </div>
            );

            return (
                <div>
                    <section style={{ marginLeft: 5, marginTop: 15 }}>{allCharCheckBox}</section>
                    <section style={styles.container}>
                        {urbanRuralDiv}
                        {PEPFAR_CatDiv}
                        {VMMC_CatDiv}
                        {DREAMS_Div}
                        {USG_AgenciesDiv}
                        {implPartnersDiv}
                        {servDelivModesDiv}
                        {ownershipDiv}
                    </section>
                </div>
            );
        } catch (exception) {
            alert(exception.name + ": " + exception.message);
        }
    };

    render() {
        try {
            if (this.state.configDrawer === null) {
                return null;
            }

            return this.renderCharacteristics();
        } catch (exception) {
            return (
                <div
                    className={"SCCharacteristicsDrawerDiv"}
                    key={"SCCharacteristicsDrawerDiv"}
                >
                    <h3 key={"SCCharacteristicsDrawerDivH3"}>{exception.name + ": " + exception.message}</h3>
                </div>
            );
        }
    }
}

export default SCCharacteristicsDrawer;
